import React, { useState } from "react";
import { Lock, Compass, CalendarClock, Sparkles } from "lucide-react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";

const BRIDGES = [
  { key: "direction", icon: Compass, title: "Executive Career Direction", testId: "locked-bridge-direction",
    desc: "Compare career paths, market demand and income trajectories to choose your next move with conviction." },
  { key: "plan", icon: CalendarClock, title: "Strategic 90-Day Plan", testId: "locked-bridge-plan",
    desc: "A sequenced 30/60/90-day skill-acquisition and positioning roadmap to close gaps for your target role." },
];

const UpgradeBridges = ({ compact = false }) => {
  const [open, setOpen] = useState(false);

  const dialog = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="bg-white border-slate-200 text-slate-900">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Lock className="w-5 h-5 text-sky-600" /> Coming in tomorrowsjob Pro</DialogTitle>
          <DialogDescription className="text-slate-500">
            Career Direction and the Strategic 90-Day Plan are part of tomorrowsjob Pro. They're locked in this preview — your Career Snapshot, Resume Health, Top Roles and one-click targeted resumes are fully available right now.
          </DialogDescription>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );

  if (compact) {
    return (
      <>
        <div className="relative overflow-hidden border border-sky-200 bg-gradient-to-br from-sky-50 via-sky-50 to-white p-5 rounded-xl h-full flex flex-col items-center justify-center text-center" data-testid="locked-bridge-direction">
          <div className="w-11 h-11 rounded-full bg-sky-50 border border-sky-200 flex items-center justify-center mb-3"><Lock className="w-5 h-5 text-sky-700" /></div>
          <h4 className="font-bold text-slate-900">Unlock Career Direction</h4>
          <p className="text-xs text-slate-500 mt-1.5 leading-relaxed">Get personalized learning paths and advanced role insights. Upgrade to Premium.</p>
          <Button onClick={() => setOpen(true)} className="mt-4 w-full bg-white text-slate-900 hover:bg-slate-200 font-semibold" data-testid="unlock-now-button">Unlock Now</Button>
        </div>
        {dialog}
      </>
    );
  }

  return (
    <div className="grid gap-4 sm:grid-cols-2" data-testid="upgrade-bridges-container">
      {BRIDGES.map((b) => {
        const Icon = b.icon;
        return (
          <div key={b.key} className="relative overflow-hidden border border-sky-200 bg-gradient-to-br from-sky-50 via-white to-white p-6 rounded-xl" data-testid={b.testId}>
            <div className="absolute top-4 right-4"><Lock className="w-4 h-4 text-sky-600" /></div>
            <Icon className="w-7 h-7 text-sky-600 mb-3" />
            <h4 className="font-bold text-slate-900">{b.title}</h4>
            <p className="text-sm text-slate-500 mt-1.5 leading-relaxed">{b.desc}</p>
            <Button onClick={() => setOpen(true)} variant="outline" className="mt-4 border-sky-200 text-sky-700 hover:bg-sky-50 hover:text-sky-700" data-testid={`upgrade-trigger-${b.key}`}>
              <Sparkles className="w-4 h-4 mr-1.5" /> Unlock
            </Button>
          </div>
        );
      })}
      {dialog}
    </div>
  );
};

export default UpgradeBridges;
